// import React, { useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import { Star, X, Send } from "lucide-react";
// import { URL } from "../../config";

// const StarRating = ({ rating, setRating }) => {
//   const starValues = [1, 2, 3, 4, 5];
//   return (
//     <div style={{ marginBottom: "1rem" }}>
//       <h3 style={{ fontSize: "0.9rem", fontWeight: "600", textAlign: "center", marginBottom: "0.5rem" }}>
//         Rate your experience
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.4rem" }}>
//         {starValues.map((value) => {
//           const isFilled = value <= rating;
//           return (
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               title={
//                 value === 1 ? "Very Poor" :
//                 value === 2 ? "Poor" :
//                 value === 3 ? "Average" :
//                 value === 4 ? "Good" : "Excellent"
//               }
//             >
//               <Star
//                 size={28}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   transition: "color 0.2s",
//                 }}
//               />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// const ServitorReviewModal = ({ order, onClose, onReviewSubmit }) => {
//   const [rating, setRating] = useState(0);
//   const [selectedOption, setSelectedOption] = useState("");
//   const [otherReview, setOtherReview] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   // Define 5 review options: 4 fixed + "Other"
//   const reviewOptions = [
//     {
//       id: "excellent",
//       label: "Excellent Customer",
//       icon: "😃",
//       bgColor: "#D1FAE5",
//       borderColor: "#A7F3D0",
//       textColor: "#065F46",
//     },
//     {
//       id: "good",
//       label: "Good Customer",
//       icon: "😊",
//       bgColor: "#DBEAFE",
//       borderColor: "#BFDBFE",
//       textColor: "#1E3A8A",
//     },
//     {
//       id: "average",
//       label: "Average Customer",
//       icon: "😐",
//       bgColor: "#FEF3C7",
//       borderColor: "#FDE68A",
//       textColor: "#92400E",
//     },
//     {
//       id: "poor",
//       label: "Poor Customer",
//       icon: "😞",
//       bgColor: "#FEE2E2",
//       borderColor: "#FECACA",
//       textColor: "#991B1B",
//     },
//     {
//       id: "other",
//       label: "Other (please specify)",
//       icon: "✍️",
//       bgColor: "#F3F4F6",
//       borderColor: "#E5E7EB",
//       textColor: "#374151",
//     },
//   ];

//   const getFinalReview = () => {
//     const selected = reviewOptions.find((opt) => opt.id === selectedOption);
//     if (selectedOption === "other") {
//       return otherReview;
//     } else if (selected) {
//       return selected.label;
//     }
//     return "";
//   };

//   const handleSubmitReview = async () => {
//     setSubmitting(true);
//     try {
//       const payload = {
//         orderId: order.Id,
//         userId: order.userId,       // The customer being reviewed
//         servitorId: order.servitor_id, // The servitor giving the review
//         rating,
//         review: getFinalReview(),
//       };
//       const response = await fetch(`${URL}/orders/${order.Id}/servitor-review`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         onReviewSubmit();
//       } else {
//         console.error("Failed to submit review");
//       }
//     } catch (error) {
//       console.error("Error submitting review:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       dialogClassName="custom-wide-modal"
//       style={{
//         // maxWidth: "900px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "0.8rem 1.2rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.2rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.1rem", margin: "0 auto" }}>
//           Review & Feedback
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ padding: "1.2rem", textAlign: "center" }}>
//         <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
//           Please rate the customer for this order.
//         </p>
//         {/* Optional Star Rating */}
//         <StarRating rating={rating} setRating={setRating} />

//         {/* Review options in 2-column grid for first 4 options */}
//         <div
//           style={{
//             display: "grid",
//             gridTemplateColumns: "1fr 1fr",
//             gap: "0.5rem",
//             marginBottom: "1rem",
//           }}
//         >
//           {reviewOptions.slice(0, 4).map((option) => {
//             const isSelected = selectedOption === option.id;
//             return (
//               <label
//                 key={option.id}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   padding: "0.5rem",
//                   borderRadius: "0.5rem",
//                   cursor: "pointer",
//                   transition: "all 0.2s",
//                   border: isSelected ? `2px solid ${option.borderColor}` : "1px solid #e5e7eb",
//                   backgroundColor: isSelected ? option.bgColor : "#fff",
//                 }}
//                 onClick={() => {
//                   setSelectedOption(option.id);
//                 }}
//               >
//                 <input
//                   type="radio"
//                   name="reviewOption"
//                   value={option.id}
//                   checked={isSelected}
//                   readOnly
//                   style={{ width: "0.9rem", height: "0.9rem" }}
//                 />
//                 <span style={{ marginLeft: "0.5rem", fontSize: "1.1rem" }}>
//                   {option.icon}
//                 </span>
//                 <span
//                   style={{
//                     marginLeft: "0.4rem",
//                     fontSize: "0.85rem",
//                     color: isSelected ? option.textColor : "#374151",
//                   }}
//                 >
//                   {option.label}
//                 </span>
//               </label>
//             );
//           })}
//         </div>

//         {/* "Other" option spanning full row */}
//         <div
//           style={{
//             marginTop: "0.5rem",
//             display: "flex",
//             alignItems: "center",
//             padding: "0.5rem",
//             borderRadius: "0.5rem",
//             cursor: "pointer",
//             transition: "all 0.2s",
//             border:
//               selectedOption === "other"
//                 ? `2px solid ${reviewOptions[4].borderColor}`
//                 : "1px solid #e5e7eb",
//             backgroundColor: selectedOption === "other" ? reviewOptions[4].bgColor : "#fff",
//           }}
//           onClick={() => setSelectedOption("other")}
//         >
//           <input
//             type="radio"
//             name="reviewOption"
//             value="other"
//             checked={selectedOption === "other"}
//             readOnly
//             style={{ width: "0.9rem", height: "0.9rem" }}
//           />
//           <span style={{ marginLeft: "0.5rem", fontSize: "1.1rem" }}>
//             {reviewOptions[4].icon}
//           </span>
//           <span
//             style={{
//               marginLeft: "0.4rem",
//               fontSize: "0.85rem",
//               color: selectedOption === "other" ? reviewOptions[4].textColor : "#374151",
//             }}
//           >
//             {reviewOptions[4].label}
//           </span>
//         </div>

//         {/* Textarea for "Other" review */}
//         {selectedOption === "other" && (
//           <div style={{ marginTop: "0.5rem" }}>
//             <Form.Group>
//               <Form.Label
//                 style={{
//                   fontSize: "0.8rem",
//                   fontWeight: 500,
//                   color: "#374151",
//                   marginBottom: "0.25rem",
//                 }}
//               >
//                 Please provide more details
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 value={otherReview}
//                 onChange={(e) => setOtherReview(e.target.value)}
//                 placeholder="Enter additional feedback..."
//                 style={{
//                   fontSize: "0.8rem",
//                   padding: "0.5rem",
//                   borderRadius: "0.5rem",
//                 }}
//               />
//             </Form.Group>
//           </div>
//         )}
//       </Modal.Body>
//       <Modal.Footer
//         style={{
//           justifyContent: "center",
//           borderTop: "1px solid #e5e7eb",
//           padding: "0.75rem 1.5rem",
//         }}
//       >
//         <Button
//           variant="secondary"
//           onClick={onClose}
//           disabled={submitting}
//           style={{
//             padding: "0.4rem 1.2rem",
//             fontSize: "0.9rem",
//           }}
//         >
//           Cancel
//         </Button>
//         <Button
//           variant="primary"
//           onClick={handleSubmitReview}
//           disabled={submitting}
//           style={{
//             padding: "0.4rem 1.2rem",
//             fontSize: "0.9rem",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//         >
//           <Send size={16} />
//           {submitting ? "Submitting..." : "Submit Review"}
//         </Button>
//       </Modal.Footer>
//       {/* Inline style for centering modal */}
//       <style>{`
//         .custom-wide-modal {
//           display: flex !important;
//           align-items: center !important;
//           justify-content: center !important;
//           margin: 0 auto !important;
//         }
//       `}</style>
//     </Modal>
//   );
// };

// export default ServitorReviewModal;

// ***** Checked All okay and working (26-6-25) ***** //

// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { Star, X, Send } from "lucide-react";
// import { URL } from "../../config";

// const StarRating = ({ rating, setRating }) => {
//   const starValues = [1, 2, 3, 4, 5];
//   return (
//     <div style={{ marginBottom: "1rem" }}>
//       <h3 style={{ fontSize: "0.9rem", fontWeight: "600", textAlign: "center", marginBottom: "0.5rem" }}>
//         Rate your experience
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.4rem" }}>
//         {starValues.map((value) => {
//           const isFilled = value <= rating;
//           return (
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               title={
//                 value === 1 ? "Very Poor" :
//                 value === 2 ? "Poor" :
//                 value === 3 ? "Average" :
//                 value === 4 ? "Good" : "Excellent"
//               }
//             >
//               <Star
//                 size={28}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   transition: "color 0.2s",
//                 }}
//               />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// const ServitorReviewModal = ({ order, onClose, onReviewSubmit }) => {
//   const [rating, setRating] = useState(0);
//   const [submitting, setSubmitting] = useState(false);

//   // When the servitor submits the review, we only send the rating.
//   const handleSubmitReview = async () => {
//     setSubmitting(true);
//     try {
//       const payload = {
//         orderId: order.Id,
//         userId: order.userId,       // The customer get reviewed
//         servitorId: order.servitor_id, // The servitor giving the review
//         rating,
//         serviceType: order.Service.services_name
//       };
//       const response = await fetch(`${URL}/orders/${order.Id}/servitor-review`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         onReviewSubmit();
//       } else {
//         console.error("Failed to submit review");
//       }
//     } catch (error) {
//       console.error("Error submitting review:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       dialogClassName="custom-wide-modal"
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "0.8rem 1.2rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#6b7280",
//             cursor: "pointer",
//             padding: "0.2rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#6b7280")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.1rem", margin: "0 auto" }}>
//           Rate the Customer
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ padding: "1.2rem", textAlign: "center" }}>
//         <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
//           Please rate the customer for this order.
//         </p>
//         <StarRating rating={rating} setRating={setRating} />
//       </Modal.Body>
//       <Modal.Footer style={{ justifyContent: "center", borderTop: "1px solid #e5e7eb", padding: "0.75rem 1.5rem" }}>
//         <Button
//           variant="secondary"
//           onClick={onClose}
//           disabled={submitting}
//           style={{ padding: "0.4rem 1.2rem", fontSize: "0.9rem" }}
//         >
//           Cancel
//         </Button>
//         <Button
//           variant="primary"
//           onClick={handleSubmitReview}
//           disabled={submitting}
//           style={{
//             padding: "0.4rem 1.2rem",
//             fontSize: "0.9rem",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//         >
//           <Send size={16} />
//           {submitting ? "Submitting..." : "Submit Review"}
//         </Button>
//       </Modal.Footer>

//       <style>{`
//         .custom-wide-modal {
//           display: flex !important;
//           align-items: center !important;
//           justify-content: center !important;
//           margin: 0 auto !important;
//         }
//       `}</style>
//     </Modal>
//   );
// };

// export default ServitorReviewModal;

// ***** Upper code Checked All okay and working (26-6-25) ***** //






// ***** Add Translator EN BN (26-6-25) ***** //


// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import { Star, X, Send } from "lucide-react";
// import { URL } from "../../config";
// import { useTranslation } from "react-i18next";

// const StarRating = ({ rating, setRating }) => {
//   const { t } = useTranslation("servitor");

//   const starValues = [1, 2, 3, 4, 5];
//   const [hoveredStar, setHoveredStar] = useState(null);

//   return (
//     <div style={{ marginBottom: "1rem" }}>
//       <h3 style={{ fontSize: "0.9rem", fontWeight: "600", textAlign: "center", marginBottom: "0.5rem" }}>
//         {/* Rate your experience */}
//         {t("viewOrderDetails.servitorReviewModal.rateExperience")}
//       </h3>
//       <div style={{ display: "flex", justifyContent: "center", gap: "0.4rem" }}>
//         {starValues.map((value) => {
//           // const isFilled = value <= rating;
//           const isFilled = value <= (hoveredStar || rating);
//           const isHovered = value === hoveredStar;
//           return (
//             <div key={value} style={{ position: "relative" }}>
//             <button
//               key={value}
//               onClick={() => setRating(value)}
//               // onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
//               // onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               onMouseOver={() => setHoveredStar(value)} // NEW: Set hovered star
//               onMouseOut={() => setHoveredStar(null)} // NEW: Clear hovered star
//               onFocus={() => setHoveredStar(value)} // NEW: Support keyboard focus
//               onBlur={() => setHoveredStar(null)} // NEW: Clear on focus out

//               style={{
//                 backgroundColor: "transparent",
//                 border: "none",
//                 cursor: "pointer",
//                 transition: "transform 0.2s",
//                 padding: 0,
//               }}
//               // title={
//               //   value === 1 ? "Very Poor" :
//               //   value === 2 ? "Poor" :
//               //   value === 3 ? "Average" :
//               //   value === 4 ? "Good" : "Excellent"
//               // }
//               title={t(`viewOrderDetails.servitorReviewModal.starRatings.${value}`)}
//               aria-label={t(`viewOrderDetails.servitorReviewModal.starRatings.${value}`)}
//               aria-describedby={`star-rating-desc-${value}`}
//             >
//               <Star
//                 size={30}
//                 style={{
//                   color: isFilled ? "#FBBF24" : "#D1D5DB",
//                   fill: isFilled ? "#FBBF24" : "none",
//                   // transition: "color 0.2s",
//                   transition: "color 0.3s, fill 0.3s",
//                 }}
//               />
//             </button>

//             {/* NEW: Hidden span for screen readers */}
//               <span id={`star-rating-desc-${value}`} style={{ display: "none" }}>
//                 {t(`viewOrderDetails.servitorReviewModal.starRatings.${value}`)}
//               </span>
//               {/* NEW: Tooltip for hover */}
//               {isHovered && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "-2.5rem", // Position above the star
//                     left: "50%",
//                     transform: "translateX(-50%)",
//                     backgroundColor: "#333",
//                     color: "#fff",
//                     padding: "0.3rem 0.6rem",
//                     borderRadius: "4px",
//                     fontSize: "0.8rem",
//                     whiteSpace: "nowrap",
//                     opacity: isHovered ? 1 : 0,
//                     transition: "opacity 0.2s",
//                     zIndex: 10,
//                   }}
//                 >
//                   {t(`viewOrderDetails.servitorReviewModal.starRatings.${value}`)}
//                 </div>
//               )}
//             </div>

//           );
//         })}
//       </div>
//       {/* NEW: Responsive styles for tooltip positioning */}
//       <style>{`
//         @media (max-width: 768px) {
//           .star-tooltip {
//             top: auto !important;
//             bottom: -2.5rem !important; /* Move tooltip below on small screens */
//           }
//         }
//       `}</style>
      
//     </div>
//   );
// };

// const ServitorReviewModal = ({ order, onClose, onReviewSubmit }) => {
//   const { t } = useTranslation("servitor");

//   const [rating, setRating] = useState(0);
//   const [submitting, setSubmitting] = useState(false);

//   // When the servitor submits the review, we only send the rating.
//   const handleSubmitReview = async () => {
//     setSubmitting(true);
//     try {
//       const payload = {
//         orderId: order.Id,
//         userId: order.userId,       // The customer get reviewed
//         servitorId: order.servitor_id, // The servitor giving the review
//         rating,
//         serviceType: order.Service.services_name
//       };
//       const response = await fetch(`${URL}/orders/${order.Id}/servitor-review`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       if (response.ok) {
//         onReviewSubmit();
//       } else {
//         console.error("Failed to submit review");
//       }
//     } catch (error) {
//       console.error("Error submitting review:", error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Modal
//       show
//       onHide={onClose}
//       centered
//       dialogClassName="custom-wide-modal"
//       style={{
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Modal.Header
//         style={{
//           borderBottom: "1px solid #e5e7eb",
//           padding: "0.8rem 1.2rem",
//           position: "relative",
//         }}
//       >
//         <button
//           type="button"
//           onClick={onClose}
//           style={{
//             position: "absolute",
//             top: "0.75rem",
//             right: "1rem",
//             backgroundColor: "transparent",
//             border: "none",
//             color: "#3a3e45",
//             cursor: "pointer",
//             padding: "0.2rem",
//             borderRadius: "0.25rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
//           onMouseOut={(e) => (e.currentTarget.style.color = "#3a3e45")}
//           aria-label={t("viewOrderDetails.close")}
//         >
//           <X size={20} />
//         </button>
//         <Modal.Title style={{ fontWeight: "bold", fontSize: "1.1rem", margin: "0 auto" }}>
//           {/* Rate the Customer */}
//           {t("viewOrderDetails.servitorReviewModal.title")}
//         </Modal.Title>
//       </Modal.Header>
//       <Modal.Body style={{ padding: "1.2rem", textAlign: "center" }}>
//         <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
//           {/* Please rate the customer for this order. */}
//           {t("viewOrderDetails.servitorReviewModal.message")}
//         </p>
//         <StarRating rating={rating} setRating={setRating} />
//       </Modal.Body>
//       <Modal.Footer style={{ justifyContent: "center", borderTop: "1px solid #e5e7eb", padding: "0.75rem 1.5rem" }}>
//         <Button
//           variant="secondary"
//           onClick={onClose}
//           disabled={submitting}
//           style={{ padding: "0.4rem 1.2rem", fontSize: "0.9rem" }}
//           aria-label={t("viewOrderDetails.servitorReviewModal.cancel")}
//         >
//           {/* Cancel */}
//           {t("viewOrderDetails.servitorReviewModal.cancel")}
//         </Button>
//         <Button
//           variant="primary"
//           onClick={handleSubmitReview}
//           disabled={submitting}
//           style={{
//             padding: "0.4rem 1.2rem",
//             fontSize: "0.9rem",
//             display: "flex",
//             alignItems: "center",
//             gap: "0.5rem",
//           }}
//           onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2563EB")}
//           onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
//           aria-label={t("viewOrderDetails.servitorReviewModal.submitReview")}
//         >
//           <Send size={16} />
//           {/* {submitting ? "Submitting..." : "Submit Review"} */}
//           {submitting ? t("viewOrderDetails.servitorReviewModal.submitting") : t("viewOrderDetails.servitorReviewModal.submitReview")}
//         </Button>
//       </Modal.Footer>

//       <style>{`
//         .custom-wide-modal {
//           display: flex !important;
//           align-items: center !important;
//           justify-content: center !important;
//           margin: 0 auto !important;
//         }
//       `}</style>
//     </Modal>
//   );
// };

// export default ServitorReviewModal;





// ***** New design with avatar order number and user name ***** //

import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Star, X, Send } from "lucide-react";
import { URL } from "../../config";
import { useTranslation } from "react-i18next";

/* ---------- helpers: initials + color hashing ---------- */
function getInitialsFromName(fullName) {
  if (!fullName) return "U";
  // take first two words’ first letters
  const parts = String(fullName)
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  const initials = parts.map((p) => p[0]?.toUpperCase() || "").join("");
  return initials || "U";
}

function hashStringToInt(str) {
  // simple deterministic hash
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash |= 0;
  }
  return Math.abs(hash);
}

// soft background + readable text palettes
const AVATAR_BG = [
  "#EEF2FF", // indigo-50
  "#ECFEFF", // cyan-50
  "#F0FDF4", // green-50
  "#FEF3C7", // amber-200
  "#FCE7F3", // pink-100
  "#E0F2FE", // sky-100
  "#EDE9FE", // violet-100
  "#FFF7ED", // orange-100
];
const AVATAR_FG = [
  "#3730A3", // indigo-800
  "#155E75", // cyan-800
  "#065F46", // green-800
  "#92400E", // amber-800
  "#9D174D", // pink-800
  "#0C4A6E", // sky-800
  "#5B21B6", // violet-800
  "#9A3412", // orange-800
];

function getAvatarColors(name) {
  const h = hashStringToInt(name || "User");
  const idx = h % AVATAR_BG.length;
  return { bg: AVATAR_BG[idx], fg: AVATAR_FG[idx] };
}
/* ------------------------------------------------------- */

const StarRating = ({ rating, setRating, error }) => {
  const { t } = useTranslation("servitor");
  const starValues = [1, 2, 3, 4, 5];
  const [hoveredStar, setHoveredStar] = useState(null);

  return (
    <div style={{ marginBottom: "0.75rem" }}>
      <h3
        style={{
          fontSize: "0.95rem",
          fontWeight: 600,
          textAlign: "center",
          marginBottom: "0.5rem",
        }}
      >
        {t("viewOrderDetails.servitorReviewModal.rateExperience")}
      </h3>
      <div style={{ display: "flex", justifyContent: "center", gap: "0.4rem" }}>
        {starValues.map((value) => {
          const isFilled = value <= (hoveredStar || rating);
          return (
            <button
              key={value}
              onClick={() => setRating(value)}
              onMouseOver={() => setHoveredStar(value)}
              onMouseOut={() => setHoveredStar(null)}
              onFocus={() => setHoveredStar(value)}
              onBlur={() => setHoveredStar(null)}
              style={{
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                padding: 0,
              }}
              title={t(
                `viewOrderDetails.servitorReviewModal.starRatings.${value}`,
              )}
              aria-label={t(
                `viewOrderDetails.servitorReviewModal.starRatings.${value}`,
              )}
            >
              <Star
                size={30}
                style={{
                  color: isFilled ? "#FBBF24" : "#D1D5DB",
                  fill: isFilled ? "#FBBF24" : "none",
                  transition: "color 0.2s, fill 0.2s",
                }}
              />
            </button>
          );
        })}
      </div>
      {error ? (
        <div
          style={{
            color: "#DC2626",
            fontSize: "0.85rem",
            marginTop: "0.4rem",
            textAlign: "center",
          }}
        >
          {error}
        </div>
      ) : null}
    </div>
  );
};

const ServitorReviewModal = ({ order, onClose, onReviewSubmit }) => {
  const { t } = useTranslation("servitor");

  const [rating, setRating] = useState(0);
  const [ratingError, setRatingError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // fetched user profile (only to get name)
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  useEffect(() => {
    let ignore = false;
    const fetchUser = async () => {
      try {
        if (!order?.userId) {
          setLoadingUser(false);
          return;
        }
        const res = await fetch(`${URL}/user/${order.userId}`);
        if (!res.ok) throw new Error("Failed to fetch user");
        const data = await res.json();
        if (!ignore) {
          setUser(data);
          setLoadingUser(false);
        }
      } catch (e) {
        if (!ignore) {
          console.error(e);
          setLoadingUser(false);
        }
      }
    };
    fetchUser();
    return () => {
      ignore = true;
    };
  }, [order?.userId]);

  const handleSubmitReview = async () => {
    if (!rating) {
      setRatingError(
        t("viewOrderDetails.servitorReviewModal.giveRating") ||
          "Please give a rating.",
      );
      return;
    }
    setRatingError("");
    setSubmitting(true);
    try {
      const payload = {
        orderId: order.Id,
        userId: order.userId,
        servitorId: order.servitor_id,
        rating,
        serviceType: order.Service?.services_name,
      };
      const response = await fetch(
        `${URL}/orders/${order.Id}/servitor-review`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );
      // if (response.ok) {
      //   onReviewSubmit();
      // } else {
      //   console.error("Failed to submit review");
      // }

      if (response.ok) {
        if (typeof onReviewSubmit === "function") {
          onReviewSubmit();
        }
        if (typeof onClose === "function") {
          onClose();
        }
      } else {
        console.error("Failed to submit review");
      }
    } catch (error) {
      console.error("Error submitting review:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const fullName =
    (user?.FirstName || user?.firstName || "") +
    (user?.LastName || user?.lastName
      ? ` ${user?.LastName || user?.lastName}`
      : "");
  const displayName = loadingUser
    ? t("viewOrderDetails.loading")
    : fullName || t("viewOrderDetails.unknown_user");
  const initials = getInitialsFromName(fullName || "User");
  const { bg: avatarBg, fg: avatarFg } = getAvatarColors(fullName || "User");

  return (
    <Modal
      show
      onHide={onClose}
      centered
      dialogClassName="custom-wide-modal"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Modal.Header
        style={{
          borderBottom: "1px solid #e5e7eb",
          padding: "0.8rem 1.2rem",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            backgroundColor: "transparent",
            border: "none",
            color: "#3a3e45",
            cursor: "pointer",
            padding: "0.2rem",
            borderRadius: "0.25rem",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "#000")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#3a3e45")}
          aria-label={t("viewOrderDetails.close")}
        >
          <X size={20} />
        </button>
        <Modal.Title
          style={{ fontWeight: "bold", fontSize: "1.1rem", margin: "0 auto" }}
        >
          {t("viewOrderDetails.servitorReviewModal.title")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "1.2rem" }}>
        {/* Target summary card */}
        <div
          style={{
            display: "flex",
            gap: "0.9rem",
            alignItems: "center",
            padding: "0.85rem",
            border: "1px solid #e5e7eb",
            borderRadius: "0.75rem",
            marginBottom: "0.9rem",
            background: "#F9FAFB",
          }}
        >
          {/* Initials avatar */}
          <div
            aria-hidden="true"
            style={{
              width: 54,
              height: 54,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: "1rem",
              background: avatarBg,
              color: avatarFg,
              border: "1px solid #e5e7eb",
              userSelect: "none",
            }}
          >
            {initials}
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <div style={{ fontWeight: 600, fontSize: "0.98rem" }}>
              {displayName}
            </div>

            <div
              style={{
                display: "flex",
                gap: "0.5rem",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {/* Order number chip */}
              {order?.order_number ? (
                <span
                  style={{
                    fontSize: "0.8rem",
                    padding: "0.15rem 0.5rem",
                    borderRadius: "9999px",
                    background: "#EEF2FF",
                    border: "1px solid #E0E7FF",
                  }}
                  title={t("viewOrderDetails.order_number")}
                >
                  #{order.order_number}
                </span>
              ) : null}

              {/* Service chip */}
              {order?.Service?.services_name ? (
                <span
                  style={{
                    fontSize: "0.8rem",
                    padding: "0.15rem 0.5rem",
                    borderRadius: "9999px",
                    background: "#ECFDF5",
                    border: "1px solid #D1FAE5",
                  }}
                  title={t("viewOrderDetails.service")}
                >
                  {order.Service.services_name}
                </span>
              ) : null}
            </div>

            {/*  BIG Amount Highlight (modern + responsive) */}
            {order?.price != null && !Number.isNaN(Number(order.price)) && (
              <div
                style={{
                  marginTop: "0.65rem",
                  padding: "0.7rem 0.85rem",
                  borderRadius: "0.85rem",
                  border: "1px solid #FED7AA",
                  background:
                    "linear-gradient(135deg, #FFF7ED 0%, #FFFBEB 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "0.75rem",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    fontWeight: 900,
                    color: "#9A3412",
                    display: "flex",
                    alignItems: "baseline",
                    gap: "0.35rem",
                    whiteSpace: "normal",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    lineHeight: 1,
                  }}
                >
                  <span style={{ fontSize: "1.05rem", opacity: 0.9 }}>৳</span>
                  <span
                    style={{
                      fontSize: "1.55rem", // BIG number
                      letterSpacing: "0.2px",
                    }}
                  >
                    {Number(order.price).toLocaleString("en-BD")}
                  </span>
                  <span style={{ fontSize: "0.95rem", opacity: 0.9 }}>Tk</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <p
          style={{
            fontSize: "0.95rem",
            marginBottom: "0.75rem",
            textAlign: "center",
          }}
        >
          {t("viewOrderDetails.servitorReviewModal.message")}
        </p>

        <StarRating
          rating={rating}
          setRating={(v) => {
            setRating(v);
            setRatingError("");
          }}
          error={ratingError}
        />
      </Modal.Body>

      <Modal.Footer
        style={{
          justifyContent: "center",
          borderTop: "1px solid #e5e7eb",
          padding: "0.75rem 1.5rem",
        }}
      >
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={submitting}
          style={{ padding: "0.45rem 1.2rem", fontSize: "0.9rem" }}
          aria-label={t("viewOrderDetails.servitorReviewModal.cancel")}
        >
          {t("viewOrderDetails.servitorReviewModal.cancel")}
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmitReview}
          disabled={submitting}
          style={{
            padding: "0.45rem 1.2rem",
            fontSize: "0.9rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#2563EB")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "#3B82F6")
          }
          aria-label={t("viewOrderDetails.servitorReviewModal.submitReview")}
        >
          <Send size={16} />
          {submitting
            ? t("viewOrderDetails.servitorReviewModal.submitting")
            : t("viewOrderDetails.servitorReviewModal.submitReview")}
        </Button>
      </Modal.Footer>

      <style>{`
        .custom-wide-modal {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 auto !important;
        }
      `}</style>
    </Modal>
  );
};

export default ServitorReviewModal;
